import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'findAndHightLightText',
    standalone: false
})
export class FindAndHightLightTextPipe implements PipeTransform {
  public transform(value: string, FindArr: any) {
    value = value.toString().replace(/COVID-19|CLOUSURE/gi, (x) => {
      return "<span class='styled_text'>" + x + '</span>';
    });
    return value;
  }
}
